import { Box, Typography } from "@mui/material";

export default function NoData({ message = "No Data" }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100px",
        backgroundColor: "bg.secondary",
        margin: "16px",
        boxSizing: "border-box",
        borderRadius: "8px",
        padding: "16px",
      }}
    >
      <Typography variant="body1">{message}</Typography>
    </Box>
  );
}
